import React from "react";
import { Sparkles } from "lucide-react";
import AdaptiveCompanionChatV2 from "@/components/daily/AdaptiveCompanionChatV2";
import { AppCard, AppPageHeader } from "@/components/daily/CompanionAppUi";

const CompanionAiPage = ({
  assessment,
  checkIn,
  plan,
  entries,
  biometrics,
  summary,
  progress,
  upcomingEvents,
  nextEventGuidance,
  workoutSourceId,
  onAddWorkoutToCalendar,
  onOpenCalendar,
  onRematch,
}) => {
  const preferredName = assessment?.identity?.preferredName;
  return (
    <div data-testid="companion-ai-page">
      <AppPageHeader
        eyebrow="Adaptive Companion"
        title={
          preferredName
            ? `${preferredName}, what do you want to understand?`
            : "What do you want to understand?"
        }
        body="Ask why you may be feeling something physically or mentally, how the two can be connected, why today’s suggestion fits your nervous-system state, request a matched workout, or problem-solve another option."
        action={<Sparkles size={24} className="forr-text-teal-deep" />}
      />

      {!plan && (
        <AppCard tone="information" className="mb-4">
          <p className="text-sm leading-relaxed forr-text-soft">
            You can ask about your saved nervous-system baseline, body sensations,
            emotional or cognitive patterns, schedule, nutrition context, and
            methodology now. Complete a current nervous-system check-in before
            asking Companion to generate or change today’s exercise dose.
          </p>
        </AppCard>
      )}

      <AdaptiveCompanionChatV2
        assessment={assessment}
        checkIn={checkIn}
        plan={plan}
        entries={entries}
        biometrics={biometrics}
        summary={summary}
        progress={progress}
        upcomingEvents={upcomingEvents}
        nextEventGuidance={nextEventGuidance}
        workoutSourceId={workoutSourceId}
        onAddWorkoutToCalendar={onAddWorkoutToCalendar}
        onOpenCalendar={onOpenCalendar}
        onRematch={onRematch}
        embedded
      />
    </div>
  );
};

export default CompanionAiPage;
